import React from 'react'
import { Box, ToggleButtonGroup, ToggleButton, Typography } from '@mui/material'

const AltToggleButton = ({
  valueStart,
  valueEnd,
  labelStart,
  labelEnd,
  handleScaleValue,
  sectIndex,
  quesIndex,
  sx,
  valueResponse,
  ...rest
}) => {
  const handleActive = (event, newActive) => {
    handleScaleValue(newActive)
  }

  let renderArray = []
  for (let i = valueStart; i <= valueEnd; i++) {
    renderArray.push(i)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <ToggleButtonGroup
        value={valueResponse}
        exclusive
        onChange={handleActive}
        aria-label="scale"
        fullWidth
        sx={{ gap: 1, marginBottom: '10px' }}
        color="alternate"
        size="large"
      >
        {renderArray.map((i, index) =>
          rest.disabled ? (
            <ToggleButton
              disabled
              value={parseInt(i)}
              aria-label={toString(i)}
              sx={{
                border: '1px solid !important',
                borderColor: 'light-grey-text.main',
                borderRadius: '4.5px !important',
                color: 'dark-text.main',
                ...sx,
              }}
              {...rest}
              key={index}
            >
              {i}
            </ToggleButton>
          ) : (
            <ToggleButton
              value={parseInt(i)}
              aria-label={toString(i)}
              sx={{
                border: '1px solid !important',
                borderColor: 'light-grey-text.main',
                borderRadius: '4.5px !important',
                color: 'dark-text.main',
                ...sx,
              }}
              {...rest}
              key={index}
            >
              {i}
            </ToggleButton>
          )
        )}
      </ToggleButtonGroup>
      <Box display="flex" flexDirection="row" justifyContent="space-between">
        <Typography variant="h4" color="light-gray-text.main">
          {labelStart}
        </Typography>
        <Typography variant="h4" color="light-gray-text.main">
          {labelEnd}
        </Typography>
      </Box>
    </Box>
  )
}

export default AltToggleButton
